import { useState } from 'react'
import './mockTestCard.css'

function getDateFormat(d) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const dd = '0' + d.getDate()
    const h = '0' + d.getHours()
    const min = '0' + d.getMinutes()
    return dd.slice(-2) + ' ' + months[d.getMonth()] + ' ' + d.getFullYear() + ', ' + h.slice(-2) + ':' + min.slice(-2)
}

/* Two-letter mark derived from the assessment title, matching the design's
   square tile (the handoff calls it `m.abbr`). */
function getAbbr(title = '') {
    const words = title.trim().split(/\s+/).filter(Boolean)
    if (words.length === 0) return '??'
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase()
    return (words[0][0] + words[1][0]).toUpperCase()
}

const MockTestCard = ({ assessment, onReport, onDelete, deleting }) => {
    const onClick = () => { onReport(assessment.linkCode) }
    // Two-step inline confirm — deleting a mock test also drops its results.
    const [confirming, setConfirming] = useState(false)
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, background: 'var(--color-surface)', padding: 16, borderLeft: '3px solid var(--color-accent)' }}>
            <div style={{ width: 64, height: 64, flex: 'none', background: 'var(--color-neutral-800)', color: 'var(--color-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 22 }}>
                {getAbbr(assessment.title)}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 16 }}>{assessment.title}</div>
                <div style={{ fontSize: 13, marginTop: 2 }} className="text-muted">
                    {assessment.category}{assessment.subCategory ? ` › ${assessment.subCategory}` : ''}
                </div>
                <div style={{ display: 'flex', gap: 16, marginTop: 8, fontSize: 12, color: 'var(--color-neutral-700)' }}>
                    <span>{assessment.numQns} questions</span><span>·</span>
                    <span>{assessment.numTopics} topics</span><span>·</span>
                    <span>{assessment.duration} min</span><span>·</span>
                    <span>{assessment.date ? getDateFormat(new Date(assessment.date)) : ''}</span>
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 'none' }}>
                <button className="btn btn-secondary" onClick={onClick}>View Result</button>
                {confirming ? (
                    <>
                        <span style={{ fontSize: 12, color: 'var(--color-accent)', maxWidth: 150 }}>Delete this mock test and its results?</span>
                        <button
                            className="btn btn-primary"
                            disabled={deleting}
                            onClick={() => { onDelete(assessment); setConfirming(false) }}
                        >{deleting ? 'Deleting…' : 'Delete'}</button>
                        <button className="btn btn-ghost" disabled={deleting} onClick={() => setConfirming(false)}>Cancel</button>
                    </>
                ) : (
                    <button className="btn btn-ghost" title="Delete mock test" onClick={() => setConfirming(true)}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14" /></svg>
                    </button>
                )}
            </div>
        </div>
    )
}
export default MockTestCard
